import { render } from "./HeaderAvatar.vue?vue&type=template&id=d77e733a"
import script from "./HeaderAvatar.vue?vue&type=script&lang=js"
export * from "./HeaderAvatar.vue?vue&type=script&lang=js"

import "./HeaderAvatar.vue?vue&type=style&index=0&id=d77e733a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__